import { IconStack } from "@/Core/Components/IconStack";
import {
    faLock,
    faShield,
    faShieldAlt,
} from "@fortawesome/free-solid-svg-icons";

const PrivatePharmacyDisclaimer = () => {
    return (
        <div className="bg-gray-100 border-gray-200 border flex items-center p-2 rounded-md gap-4">
            <IconStack
                baseIcon={faShield}
                baseClassName="text-gray-500"
                baseSize="2x"
                overlays={[
                    {
                        icon: faLock,
                        className: "text-white pb-1",
                        size: "xs",
                    },
                ]}
            />
            <div>
                <p className="font-bold">Sav-Rx is a Private Pharmacy</p>
                <p className="text-gray-600 text-sm font-semibold">
                    Exclusively for Sav-Rx Group Members
                </p>
            </div>
        </div>
    );
};

export default PrivatePharmacyDisclaimer;
